import * as Sentry from "@sentry/browser";
import mixpanel from 'mixpanel-browser';

Sentry.init({
  dsn: "https://3fdb0c41327a83e4cb56d5b4b90581d0@o4506895983706112.ingest.us.sentry.io/4506895986524160",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

mixpanel.init('cf94a02e44ddf7e05d5845558f9f89df', {debug: true, track_pageview: true, persistence: 'localStorage'});

import axios from "axios";

import firebase from "firebase/compat/app";

import "firebase/compat/auth";
import "firebase/compat/analytics";
import "firebase/compat/database";
import "firebase/compat/firestore";

import { getQueryParamsAsObject, getQueryParamsAsString } from "../lib/util-standardfunctions";

(function () {

    'use strict';

    // Code goes here...
    console.log("JSKJM!");
    var CURR_USER = false;
    var CURR_USERPROFILE = false;
    //
    const firebaseConfig = {
        apiKey: "AIzaSyAkOAXn8FEH1PKjf_aghihKEamNddBQB18",
        authDomain: "learner-plus.firebaseapp.com",
        projectId: "learner-plus",
        storageBucket: "learner-plus.appspot.com",
        messagingSenderId: "812434383550",
        appId: "1:812434383550:web:d2cda1285d3e3199a134ef"
    };

    // capture ALL the query params
    // /nudge-reflection?ipoc_keyword=Pain+Management&ipoc_context=Meeting&cmefy_id=jskjm_id&ipoc_secret=JSKJMSecret&reflectionkit=reflective-practice
    
    var CURR_QueryParams_Str = getQueryParamsAsString(); // This includes the leading '?'
    var CURR_QueryParams_Obj = getQueryParamsAsObject();
    // hide them for safety
    history.pushState(null, '', '/nudge-reflection?processing=jskjm');
    
    // Initialize Firebase
    const app = firebase.initializeApp(firebaseConfig);
    firebase.auth().onAuthStateChanged((user)=>{
        console.log(user);
        if (user){
            // we have a user
            CURR_USER = user;
            Sentry.setContext("CURR_USER", user);
            console.log(user.uid);
            UI_BindActions();
            //
            if (CURR_QueryParams_Obj.logout){
                firebase.auth().signOut().then(() => {
                    location.reload();
                }).catch((error) => {
                    // An error happened.
                    showNotification('Logout Error', 'There was an error logging out - '+error+'.', 'error', 3000);
                });
                return;
            }
            //
            // we see if the profile is filled out otherwise move forward
            firebase.firestore().collection('userprofiles').doc(user.uid).get().then((doc)=>{
                if (doc.exists){
                    // we can take them to default/parameter reflectionkit
                    CURR_USERPROFILE = doc.data();
                    // activate free cert if param present and not already set
                    if (CURR_QueryParams_Obj.activate_free_cert === "true" && !CURR_USERPROFILE.certIncluded) {
                        firebase.firestore().collection('userprofiles').doc(user.uid).update({ certIncluded: true });
                    }
                    document.getElementById('loading_overlay').classList.add('hidden');
                    navigateToReflectivePractice_Or_ProvidedKit();
                }else{
                    // we need to ask them to fill out the profile quickly, go take them to login
                    navigateToLoginAndRegistration();
                }
            }).catch((error)=>{
                Sentry.captureException(error);
                showNotification('Profile Fetch Error', 'There was an error fetching your profile - '+error+'.', 'error', 4500);
            });
            //
        }else{
            // no authenticated user, lets force the token or try to log them in
            if (CURR_QueryParams_Obj.token){
                try{
                    firebase.auth().signInWithCustomToken(CURR_QueryParams_Obj.token).then((signInSuccess)=>{
                        navigateToLoginAndRegistration();
                    }).catch(errInToken=>{
                        navigateToLoginAndRegistration();
                    });
                }catch (ex){
                    // we push them to login manually
                    navigateToLoginAndRegistration();
                }
            }else{
                navigateToLoginAndRegistration();
            }
        }
    });
    
    function UI_BindActions(){
        document.getElementById('learnerplus').addEventListener('click', function(event) {
            // Check if the clicked element has the class 'ui-action-btn'
            if (event.target.classList.contains('ui-action-btn')) {
              event.preventDefault();
              var uiTask = event.target.getAttribute('data-task');
              performTask(uiTask);
            }
        });
    }

    function performTask(uiTask){
        switch (uiTask){
            case 'dismiss-modal':
                document.getElementById('npi').value = '';
                document.getElementById('npi-import-modal').classList.add(['hidden'])
                break;
            case "appnotifier-dismiss":
                console.log("dismisser");
                document.getElementById('appnotifier').classList.remove('opacity-100', 'scale-100');
                document.getElementById('appnotifier').classList.add('opacity-0', 'scale-95', 'hidden');
                break;
            case "logout-curruser":
                if (confirm('Are you sure you want to logout?')){
                    firebase.auth().signOut().then(() => {
                        location.reload();
                    }).catch((error) => {
                        // An error happened.
                        showNotification('Logout Error', 'There was an error logging out - '+error+'.', 'error', 3000);
                    });
                }
                break;
            default:
              // no-op
              break;
          }
    }

    /**
     * Determines the appropriate reflectionkit based on user credential
     * @param {string} credential - User's credential from profile
     * @returns {string} - The reflectionkit identifier
     */
    function getReflectionkitFromCredential(credential) {
        // Handle missing or invalid credentials
        if (!credential || credential === 'not-selected') {
            console.warn('No valid credential found, defaulting to reflective-practice');
            return 'reflective-practice';
        }

        // Credentials that should use reflective-thinking
        const REFLECTIVE_THINKING_CREDENTIALS = [
            'Lifelong-Learner',
            'Student',
            'Fellow',
            'Resident'
        ];

        if (REFLECTIVE_THINKING_CREDENTIALS.includes(credential)) {
            return 'reflective-thinking';
        }

        // Default for all other credentials (healthcare professionals)
        return 'reflective-practice';
    }

    function navigateToLoginAndRegistration(){
        if (CURR_QueryParams_Obj.redirect_url && CURR_QueryParams_Obj.redirect_url.startsWith('/') && !CURR_QueryParams_Obj.redirect_url.startsWith('//') && !CURR_QueryParams_Obj.redirect_url.startsWith('/\\')){
            window.location.href = CURR_QueryParams_Obj.redirect_url;
        }else if (CURR_QueryParams_Obj.redirect_url){
            console.warn('[Security] Blocked invalid redirect_url, falling back to /');
            window.location.href = '/';
        }else{
            // Let login page handle kit selection based on credential
            // Don't set a default here - login logic will determine based on credential
            window.location.href = `/login${CURR_QueryParams_Str}`
        }
    }

    function navigateToReflectivePractice_Or_ProvidedKit(){
        if (CURR_QueryParams_Obj.redirect_url && CURR_QueryParams_Obj.redirect_url.startsWith('/') && !CURR_QueryParams_Obj.redirect_url.startsWith('//') && !CURR_QueryParams_Obj.redirect_url.startsWith('/\\')){
            window.location.href = CURR_QueryParams_Obj.redirect_url;
        } else if (CURR_QueryParams_Obj.redirect_url) {
            console.warn('[Security] Blocked invalid redirect_url, falling back to /');
            window.location.href = '/';
        } else {
            var targetReflectionKit = '';

            const credentialKit = (CURR_USERPROFILE && CURR_USERPROFILE.credential)
                ? getReflectionkitFromCredential(CURR_USERPROFILE.credential)
                : null;

            // PRIORITY 1: Credential override for student/resident/fellow/lifelong-learner
            // These always route to reflective-thinking regardless of stored kit — matches login flow
            if (credentialKit === 'reflective-thinking') {
                targetReflectionKit = 'reflective-thinking';
                console.log('Credential requires reflective-thinking, routing accordingly:', CURR_USERPROFILE.credential);
            }
            // PRIORITY 2: Stored reflectionkit from profile (for healthcare professionals)
            else if (CURR_USERPROFILE && CURR_USERPROFILE.reflectionkits && CURR_USERPROFILE.reflectionkits[0]) {
                targetReflectionKit = CURR_USERPROFILE.reflectionkits[0];
                console.log('Using stored reflectionkit from user profile:', targetReflectionKit);
            }
            // PRIORITY 3: Credential-based selection for users without stored kit
            else if (credentialKit) {
                targetReflectionKit = credentialKit;
                console.log('Auto-selecting reflectionkit based on credential:', targetReflectionKit);
            }
            // PRIORITY 4: Fallback default
            else {
                targetReflectionKit = "reflective-practice";
                console.log('Using default reflectionkit:', targetReflectionKit);
            }

            // Sync reflectionkit param with actual routing decision
            // (credential may have overridden a stale URL param — replace it so path and param match)
            CURR_QueryParams_Str = CURR_QueryParams_Str.replace(/([?&])reflectionkit=[^&]*/g, `$1reflectionkit=${targetReflectionKit}`);
            if (!CURR_QueryParams_Str.includes('reflectionkit=')) {
                CURR_QueryParams_Str += (CURR_QueryParams_Str.includes("?") ? "&" : "?") + `reflectionkit=${targetReflectionKit}`;
            }

            window.location.href = '/' + targetReflectionKit + (CURR_QueryParams_Str ? CURR_QueryParams_Str : '');
        }
    }

    function showNotification(notificationTitle, notificationContent, notificationType, notiificationDuration){
        document.getElementById('appnotifier-title').innerHTML = notificationTitle;
        document.getElementById('appnotifier-content').innerHTML = notificationContent;
        document.getElementById('appnotifier').classList.remove('opacity-0', 'scale-95', 'hidden');
        document.getElementById('appnotifier').classList.add('opacity-100', 'scale-100');
        setTimeout(function(){
            performTask('appnotifier-dismiss');
        }, notiificationDuration);
    }
    
})();